<template>
  <ui-modal
    class="ui-modal-confirm"
    :is-open.sync="innerIsOpen"
    :cancel-button-title="getTitleCancelButton"
    :success-button-title="getTitleSuccessButton"
    :can-hide-parent="false"
    :has-header="false"
    is-footer-center
    size="s"
    @close="cancelEvent"
    @success="successEvent"
  >
    <div class="ui-modal-confirm-body">
      <ui-icon
        v-if="config.iconName"
        :name="config.iconName"
        :size="150"
        class="ui-modal-confirm-icon"
      />
      <div
        v-if="config.title"
        class="ui-modal-confirm-title"
      >
        {{ config.title }}
      </div>
      <div
        v-if="config.description"
        class="ui-modal-confirm-description"
      >
        {{ config.description }}
      </div>
    </div>
  </ui-modal>
</template>

<script>
import { UiModal } from '../../components'
import UiIcon from '../icons/UiIcon.vue'

import modalMixin from '../../mixins/modalMixin'

export const confirmModalConfig = {
  isOpen: false,
  title: null,
  description: null,
  cancelEvent: null,
  successEvent: null
}

export class ConfirmModal {
  /**
   * Создаёт конфиг для конфирма
   * @param {string} [title] - Заголовок
   * @param {string} [description] - Описание
   * @param {string} [iconName] - Название иконки
   * @param {function} [successEvent] - Метод, выполняющийся при принятии конфирма
   * @param {function} [cancelEvent] - Метод, выполняющийся при отмене конфирма
   * @param {boolean} [isOpen] - Видимость модального окна
   */
  constructor (...params) {
    this.init(...params)
  }

  init (title = null, description = null, successEvent = null, cancelEvent = null, isOpen = false) {
    this.isOpen = isOpen
    this.title = title
    this.description = description
    this.successEvent = successEvent
    this.cancelEvent = cancelEvent
  }

  open () {
    this.isOpen = true
  }

  close () {
    this.isOpen = false
  }
}

export default {
  name: 'UiModalConfirm',
  components: { UiModal, UiIcon },
  mixins: [modalMixin],
  props: {
    config: {
      type: Object,
      default: () => ({
        isOpen: false
      })
    }
  },
  methods: {
    cancelEvent () {
      this.config.cancelEvent?.()
      this.close()
    },

    successEvent () {
      this.config.successEvent?.()
      this.close()
    }
  },

  computed: {
    getTitleCancelButton () {
      return this.config.titleCancelButton || 'Отменить'
    },

    getTitleSuccessButton () {
      return this.config.titleSuccessButton || 'Продолжить'
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-modal-confirm {
  z-index: 999999999;

  &-body {
    @include flex-column-center;
    text-align: center;
  }

  &-icon {
    margin-bottom: 30px;
    fill: $blue-4;
  }

  &-title {
    @include font-title-22;
    text-align: center;
  }

  &-description {
    @include font-16;
    margin-top: 4px;
    line-height: 22px;
    color: $gray-1;
  }

  @include media-max-md {
    &-title {
      @include font-18;
    }
  }
}
</style>
